module.exports = __webpack_public_path__ + "img/bespoke70_19.dda28100.jpg";